import ProductDescription from './ProductDescription'

const InstantOatmealProduct = {
  ...ProductDescription,
  category: '05',
  subCategory: '001IO',
  IsBroadband: true,
  Kcals: null,
  Folate: '',
  Fiber: '',
  WholeGrainCert: false,
  Iron: '',
  Sucrose: '',
  Rounding: false,
  UnderIronLimit: false,
  UnderSucroseLimit: false,
  ContainsNoSweeteners: false,
  OatType: 'Instant',
  Flavor: '',
  Size: '',
}

export default InstantOatmealProduct
